// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"1a8e2a75","346":"629c470b","544":"60064901","673":"12404005","956":"7843bc66"}[chunkId] + ".chunk.css";
};